module.exports = __webpack_public_path__ + "img/kefu.f65a1d6b.png";